/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CustomerRegistrationCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UserDto, RequestOptions, OtpDto } from "../models";

@Injectable({ providedIn: "root" })
export class CustomerRegistrationCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    registration(id: string, userDto: UserDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    registration(id: string, userDto: UserDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    registration(id: string, userDto: UserDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    registration(id: string, userDto: UserDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/customers/registration/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: userDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    sendOtp(otpDto: OtpDto, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    sendOtp(otpDto: OtpDto, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    sendOtp(otpDto: OtpDto, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    sendOtp(otpDto: OtpDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/customers/registration/send-otp`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: otpDto,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    checkOtp(id: string, code: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    checkOtp(id: string, code: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    checkOtp(id: string, code: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    checkOtp(id: string, code: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/customers/registration/check-otp/${id}`;

        let params = new HttpParams();
        if (code != null) {
            params = HttpParamsBuilder.addToHttpParams(params, code, 'code');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    verifyPhoneNumber(phone: string, code: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<boolean>;
    verifyPhoneNumber(phone: string, code: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<boolean>>;
    verifyPhoneNumber(phone: string, code: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<boolean>>;
    verifyPhoneNumber(phone: string, code: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/customers/registration/phone`;

        let params = new HttpParams();
        if (phone != null) {
            params = HttpParamsBuilder.addToHttpParams(params, phone, 'phone');
        }
        if (code != null) {
            params = HttpParamsBuilder.addToHttpParams(params, code, 'code');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
